import {EventProfileInterface} from './EventProfileInterface';

export class EventChangeFiles implements EventProfileInterface {

    public watch(profileElements: HTMLCollectionOf<HTMLElement>): void {
        if (!profileElements.length) {
            return;
        }
        for (let i = 0; i < profileElements.length; i++) {
            this.watchChangeFile(profileElements[i]);
        }
    }

    /*
     * События изменения на input[type=file]
     */
    private watchChangeFile(el: HTMLElement): void {
        let file = el.querySelector('input[type="file"]');
        if (!file) {
            return;
        }
        file.addEventListener('change', (e: MouseEvent) => {
            ((e.target as HTMLElement).parentNode.parentNode as HTMLFormElement).submit();
        }, false);
    }
}